import Vue from "vue";
import "bootstrap";
import "reflect-metadata";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./styles/app.scss";
import BootstrapVue from "bootstrap-vue";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";

Vue.use(BootstrapVue);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("vue-bootstrap-typeahead", VueBootstrapTypeahead);
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
